import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { renderToStaticMarkup } from "react-dom/server";

import Storage from "react-native-storage";
import i18n from "i18n-react";
import SweetAlert from "sweetalert-react";

import { SettingsProvider } from "hooks/useSettings";

// FontAwesome
import "config/FontAwesome";

import {
  AppSettings,
  APIHandler,
  AppRouter,
  DataHandler,
  locales,
  StorageHandler,
  MobileWarning,
  CookieWarning,
} from "C4";
import { storageKeys, language, userKeys } from "settings";

import "normalize.css/normalize.css";
import "./assets/styles/styles.scss";

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
      storageBackend: cookieEnabled ? window.localStorage : {},
      defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
      enableCache: true,
      sync: {
        // TODO: Handle exiration of data (Reload data with new API Calls)
      },
    })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language.map((lang) => lang.code.toLowerCase());
const commitRisk = language.some(
  (lang) => lang.id === 220 && lang.countries.length > 0
);
if (commitRisk) {
  console.error(
    "One of the testing languages is currently in use. Please remove before committing."
  );
}

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        })
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.langFile]);
      });
    } else {
      // Get user location and check if a language file exists.
      StorageHandler.save(storageKeys.lang, {
        country: "United_States",
        code: "US",
        langFile: "en",
      });
      i18n.setTexts(locales.en);
      APIHandler.getLocation().then((location) => {
        if (location) {
          const code = location.countryCode.toLowerCase();
          const availableLanguageForUserLocation = (translationFiles) =>
            translationFiles
              .map((translation) => translation[0] === code)
              .includes(true);
          if (availableLanguageForUserLocation(availableLanguages)) {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(" ", "_"),
              code: code.toLowerCase(),
              langFile: "en",
            });
            window.location.reload();
          } else {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(" ", "_"),
              code: location.countryCode.replace(" ", "_"),
              langFile: "en",
            });
            window.location.reload();
          }
        } else {
          StorageHandler.save(storageKeys.lang, {
            country: "United_States",
            code: "US",
            langFile: "en",
          });
          i18n.setTexts(locales.en);
          window.location.reload();
        }
      });
    }
  });
  StorageHandler.load("askedMobile").then((askedBefore) => {
    ReactDOM.render(
      <App askedBefore={askedBefore} />,
      document.getElementById("root")
    );
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onMobile:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          window.navigator.userAgent
        ),
      askedBefore: this.props.askedBefore,
    };
  }

  render() {
    const { onMobile, askedBefore } = this.state;

    const setAsked = () => {
      // this.setState({ askedBefore: true });
      // StorageHandler.save('askedMobile', true);
      window.history.back();
    };

    return (
      <div className="container__router">
        <SettingsProvider>
          <AppSettings />
          {!cookieEnabled && <CookieWarning />}
          <AppRouter />
        </SettingsProvider>
      </div>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
